const DATE_FORMATS = {
  FULL: 'ddd, MMM D YYYY',
  MONTH_YEAR: 'MMMM YYYY',
  DAY_OF_WEEK: 'ddd',
  DAY_OF_MONTH: 'D',
};

export default DATE_FORMATS;



// WEBPACK FOOTER //
// ./date-formats.js